// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */

import type * as Types from '../../../../../../../../schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/shared/utils/gql';
import { BoostTimerFragmentDoc } from '../../queries/getBoostNotifications/BoostNotificationQuery.generated';
export type BoostTimerNotificationSubscriptionVariables = Types.Exact<{
  input: Types.CasinoBoostsPublicBoostTimerInput;
}>;


export type BoostTimerNotificationSubscription = { __typename?: 'Subscription', casinoBoostsPublicBoostTimerUpdated?: { __typename?: 'CasinoBoostsPublicBoostTimerPayload', clientSubscriptionId?: string, boostTimer?: { __typename?: 'CasinoBoostsPublicBoostTimer', id: string, boostAmount?: number, claimed?: boolean, rewardClaimDate?: string, currency?: string, timer?: number, timerStartAt?: any, timerEndAt?: any, userId?: string, winAmount?: number, isActive?: boolean, isLimitReached?: boolean, isTimerOver?: boolean, event?: { __typename?: 'CasinoBoostsPublicEvent', id: string, name?: string, closeAt?: any, allowedGames?: string, boostPercentage?: number, maxBoostAmount?: number, maxBetAmount?: number, boostDuration?: number, iAmOptedIn?: boolean } } } };


export const BoostTimerNotificationSubscriptionDocument = gql`
    subscription BoostTimerNotificationSubscription($input: CasinoBoostsPublicBoostTimerInput!) {
  casinoBoostsPublicBoostTimerUpdated(input: $input) {
    boostTimer {
      ...BoostTimerFragment
    }
    clientSubscriptionId
  }
}
    ${BoostTimerFragmentDoc}`;

export const useBoostTimerNotificationSubscription = (options: { variables?: BoostTimerNotificationSubscriptionVariables, onData: (data: BoostTimerNotificationSubscription) => void } ) => { 
  return useSubscription<BoostTimerNotificationSubscription, BoostTimerNotificationSubscriptionVariables>(BoostTimerNotificationSubscriptionDocument, options);
}